import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Location } from '@angular/common';
import {
  Event,
  EventClient,
  FileClient,
  RubricClient,
} from "src/app/services/apis/web-api-client";
import { FileService } from "src/app/services/file.service";

@Component({
  selector: "app-news-item",
  templateUrl: "./news-item.component.html",
  styleUrls: ["./news-item.component.scss"],
})
export class NewsItemComponent implements OnInit {
  newsItem: Event;
  rubrics = [];
  id = null;
  events = [];
  isLoading = true;
  selectedNews = null;
  open=false;
  constructor(
    private eventService: EventClient,
    private rubricService: RubricClient,
    private fileService: FileService,
    private activateRoute: ActivatedRoute,
    private location: Location,

  ) {
    this.id = activateRoute.snapshot.params["id"];
  }

  ngOnInit(): void {
    this.eventService.getOne(this.id).subscribe((data) => {
      this.newsItem = data;
      this.isLoading = false;
      console.log(this.newsItem);
    });
  }

  getImage(id: string) {
    console.log(id)
    if (id) {
      return this.fileService.getDownloadUrl(id);
    } else {
      return "/assets/user.png";
    }
  }


  back(): void {
    this.location.back()
  }

  openText(){
    this.open= !this.open;
  }

  scroll(className: string): void {
    const elementList = document.getElementById(className);
    const element = elementList[0] as HTMLElement;
    element.scrollIntoView({ behavior: "smooth" });
  }
}
